import {
  Braces,
  Crop,
  Droplets,
  EyeOff,
  FileCode2,
  FileDown,
  FileImage,
  FileSpreadsheet,
  FileText,
  GitCompare,
  Hash,
  Highlighter,
  Image,
  Layers,
  Link2,
  ListChecks,
  LayoutGrid,
  PenTool,
  RotateCw,
  ScanText,
  Scissors,
  ShieldCheck,
  Stamp,
  Wrench,
  type LucideIcon,
} from 'lucide-react';

export const TOOL_ICONS: Record<string, LucideIcon> = {
  Braces,
  Crop,
  Droplets,
  EyeOff,
  FileCode2,
  FileDown,
  FileImage,
  FileSpreadsheet,
  FileText,
  GitCompare,
  Hash,
  Highlighter,
  Image,
  Layers,
  Link2,
  ListChecks,
  LayoutGrid,
  PenTool,
  RotateCw,
  ScanText,
  Scissors,
  ShieldCheck,
  Stamp,
  Wrench,
};

export function iconFor(name: string): LucideIcon {
  return TOOL_ICONS[name] ?? Wrench;
}
